"use strict";
/**
 * @author Meiblorn (Vadim Fedorenko) <meiblorn@gmail.com | admin@meiblorn.com> on 15/05/16.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var mnFullpage_module_1 = require("./mnFullpage.module");
exports.MnFullpageModule = mnFullpage_module_1.MnFullpageModule;
var mnFullpage_directive_1 = require("./mnFullpage.directive");
exports.MnFullpageDirective = mnFullpage_directive_1.MnFullpageDirective;
var mnFullpage_options_class_1 = require("./mnFullpage-options.class");
exports.MnFullpageOptions = mnFullpage_options_class_1.MnFullpageOptions;
var mnFullpage_service_1 = require("./mnFullpage.service");
exports.MnFullpageService = mnFullpage_service_1.MnFullpageService;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/~/ngx-fullpage/components/fullpage/index.js
// module id = ../../../../ngx-fullpage/components/fullpage/index.js
// module chunks = 4